import { useMaterials } from "@root/hooks/useMaterials";
import React, { createContext, useContext, ReactNode } from "react";

const MaterialContext = createContext<any>(undefined);

interface MaterialContextProviderProps {
  children: ReactNode;
}

export const MaterialContextProvider: React.FC<
  MaterialContextProviderProps
> = ({ children }) => {
  const data = useMaterials();
  return (
    <MaterialContext.Provider value={data}>{children}</MaterialContext.Provider>
  );
};

export const useMaterialContext = () => {
  const context = useContext(MaterialContext);
  return context;
};
